// Set random ID

'use strict';

export default function setID() {
    return Date.now().toString() + Math.floor(Math.random() * 1000).toString();
}